import styled from 'styled-components';

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  article {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 0.75rem;
    overflow: hidden;
    border: 1px solid #e5e7eb;
    transition: all 0.3s;
  }

  article:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }

  .content {
    padding: 1.25rem;
  }

  h4 {
    font-family: 'Playfair Display', serif;
    font-size: 1.125rem;
    font-weight: 600;
    color: #111718;
    margin: 0 0 0.5rem 0;
  }

  .price {
    font-size: 1rem;
    font-weight: 500;
    color: #6b7280;
    margin-bottom: 0.75rem;
  }

  p {
    font-size: 0.875rem;
    color: #6b7280;
    line-height: 1.6;
    margin-bottom: 1rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.625rem 1rem;
    background: #111718;
    color: #ffffff;
    border-radius: 0.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.2s;
  }

  .btn:hover {
    background: #2d3436;
  }

  @media (min-width: 768px) {
    article {
      flex-direction: row;
    }

    img {
      width: 280px;
      height: 200px;
      flex-shrink: 0;
    }

    .content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 1.5rem;
    }
  }

  @media (min-width: 992px) {
    img {
      width: 320px;
      height: 220px;
    }
  }
`;

export default Wrapper;
